import { Checkbox } from '@village/ui';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { isLegalAge } from 'utils/date';

import { PatientInformationFormSchema } from './schema';
import * as Styled from './styles';

const GuardianCheckbox: FC = () => {
    const { register, watch, formState } = useFormContext<PatientInformationFormSchema>();
    const [guardianCheck, dateOfBirth] = watch(['guardianCheck', 'dateOfBirth']);
    const legalAge = dateOfBirth?.length === 10 ? isLegalAge(dateOfBirth) : true;

    if (!legalAge) {
        return (
            <Styled.GuardianCheckbox>
                <Checkbox
                    aria-invalid={!!formState.errors.guardianCheck}
                    {...register('guardianCheck', { shouldUnregister: true })}
                    data-testid="guardian-check"
                    id="guardian-check"
                    checked={guardianCheck === true}
                    label={
                        <span>
                            Patients under 18 must have a parent or guardian schedule their appointments *
                            <br />I certify that I am the parent or legal guardian of this individual.
                        </span>
                    }
                />
            </Styled.GuardianCheckbox>
        );
    }

    return null;
};

export { GuardianCheckbox };
